export default __webpack_public_path__ + "static/media/ab_spade.fb0e06b3.svg";